/**
 * The message of a failed API call, as the user may see it: the API's `message` (validation and other
 * errors meant for the user; a 500 is always a general message), never the raw response.
 */
export function apiErrorMessage(e, fallback) {
  const data = e?.response?.data;
  return (typeof data?.message === "string" && data.message) || (typeof data?.error === "string" && data.error) || fallback;
}
